import { breakArguments, checkArgument, findOperator } from "./customExpressionUtility";
import expressionConfig from "../configurations/QueryBuilder/ExpressionConfig";

/**
 * Return Mongo Query (JSON) corresponding to the expression
 */
const expressionEvaluator = (expr, mode = "nonAggregate") => {
	// const expression = expr.replace(/ /g, "");
	const expression = expr.trim();
	const expressionArgument = checkArgument(expression);
	if (["variable", "number", "literal", "null", "boolean", "array"].indexOf(expressionArgument) !== -1) {
		if (expressionArgument === "array") {
			return JSON.parse(expression);
		} else if (expressionArgument === "number") {
			return parseFloat(expression);
		} else if (expressionArgument === "null") {
			return null;
		} else if (expressionArgument === "boolean") {
			if (expression === "true") {
				return true;
			} else {
				return false;
			}
		} else if (expressionArgument === "literal") {
			if (expression[0] === '"' && expression[expression.length - 1] === '"') {
				return expression.slice(1, -1);
			}
		}
		return expression;
	} else {
		const args = breakArguments(expression);
		const operator = findOperator(expression);
		const config = expressionConfig[operator];
		const resolvedArguments = [];
		const numArguments =
			mode === "nonAggregate"
				? config.allowMultiple
					? args.length
					: config.numArguments
				: config.numAggArguments
				? config.numAggArguments
				: config.allowMultiple
				? args.length
				: config.numArguments;
		const convertorFunction =
			mode === "nonAggregate"
				? config.mongoConvertor
				: config.mongoAggConvertor
				? config.mongoAggConvertor
				: config.mongoConvertor;
		for (let i = 0; i < numArguments; i++) {
			resolvedArguments.push(expressionEvaluator(args[i]));
		}
		return convertorFunction(...resolvedArguments);
	}
};

export default expressionEvaluator;
